import * as yup from "yup"
import { t } from "i18next"

import { stringValidationYup } from "helpers/validations"
const tsrAddTaskValidationSchema = () =>
  yup.object().shape({
    task: stringValidationYup(t("Task type is required")).nullable(),
    subTask: stringValidationYup(t("Sub task is required")).nullable(),
    subofSubTask: stringValidationYup(t("Location is required")).nullable(),
    subLocation: stringValidationYup(t("Sub location is required")).nullable(),
    completionDate: yup.object().required(t("Completion Date is required")).nullable(),
    call: stringValidationYup().nullable(),
    deadLine: yup.object().required(t("Deadline is required")).nullable(),
    tsrClassification: stringValidationYup(t("Tsr classification is required")).nullable(),
    leadsClassification: stringValidationYup(t("Leads classification is required")).nullable(),
    nextTask: stringValidationYup(t("Next task is required")).nullable(),
    attachment: yup.array().of(yup.object().shape({ file: yup.mixed() })),
    project: yup.number().required(t("Project is required")).nullable(),
    comment: stringValidationYup().required(t("Comment is required")).nullable(),
    dateSlot: yup.object().required(t("Meeting Date is required")).nullable(),
    timeSlot: yup.array().required(t("Meeting Time is required")).nullable(),
    salesEvent: yup.string().required(t("Sales event is required")).nullable(),
  })

export default tsrAddTaskValidationSchema
